import {
  type CloudVisionSafeSearchDetectionResult,
  CloudVisionLikelihood,
  type UploadedImage,
} from '@/lib/types';

const shouldShowInappropriateContentIndicators = (
  image: UploadedImage,
): boolean => {
  if (image.file.cloudVisionSafeSearchDetectionResult === null) {
    return false;
  }

  const cloudVisionSafeSearchDetectionResult = JSON.parse(
    image.file.cloudVisionSafeSearchDetectionResult,
  ) as CloudVisionSafeSearchDetectionResult | null;

  if (cloudVisionSafeSearchDetectionResult === null) {
    return false;
  }

  // Note that images with a high likelihood of adult content (i.e. porn) will
  // not be shown altogether. Instead, the error state is shown. This is
  // handled by the backend which marks the image file status as
  // INAPPROPRIATE_CONTENT_DETECTED.
  return (
    cloudVisionSafeSearchDetectionResult.medical >=
      CloudVisionLikelihood.LIKELY ||
    cloudVisionSafeSearchDetectionResult.violence >=
      CloudVisionLikelihood.LIKELY ||
    cloudVisionSafeSearchDetectionResult.racy >= CloudVisionLikelihood.LIKELY
  );
};

export default shouldShowInappropriateContentIndicators;
